import { apiFetch } from './prospects.js';

export async function fetchTeamMembers() {
  return apiFetch('/team/members');
}

export async function createTeamMember(data) {
  return apiFetch('/team/members', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateTeamMember(id, data) {
  return apiFetch(`/team/members/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

export async function removeTeamMember(id) {
  return apiFetch(`/team/members/${id}`, {
    method: 'DELETE',
  });
}

export async function fetchTeamMemberHubupQr(id) {
  return apiFetch(`/team/members/${id}/hubup-qr`);
}
